import React, {useEffect} from 'react';
import {ActivityIndicator, Alert, FlatList, Text, View} from 'react-native';
import {styles} from './styles';
import SearchHeader from '../../components/SearchHeader/SearchHeader';
import {stylesEquipmentMaintenanceList as ls} from './styles-equipment-maintenance-list';
import ButtonComponent from '../../components/ButtonComponent/ButtonComponent';
import EquipamentsService from '../../services/EquipamentsService/EquipamentsService';
import {Colors} from '../../constants/Colors';
import {useNavigation} from '@react-navigation/native';
import {NavigationProps} from '../../navigation/Routes';
import {AppRoutes} from '../../navigation/Routes.types';
import {formatDate} from '../../utils/formatDate';
import {IMaintenanceHistoryItem} from '../../types/Equipaments';

const STATUS_COLORS: Record<string, string> = {
  pendente: Colors.GrayPallete.lightgrayThree,
  atendida: Colors.GreenPallete.greenOne,
  cancelado: Colors.RedPallete.red,
  recusada: Colors.RedPallete.red,
};

const capitalize = (value?: string) =>
  value ? value.charAt(0).toUpperCase() + value.slice(1) : '—';

const EquipmentMaintenanceList = () => {
  const navigation = useNavigation<NavigationProps>();
  const {goBack, navigate} = useNavigation<NavigationProps>();
  const [loading, setLoading] = React.useState<boolean>(true);
  const [refreshing, setRefreshing] = React.useState<boolean>(false);
  const [list, setList] = React.useState<IMaintenanceHistoryItem[]>([]);

  const requestList = async () => {
    try {
      const response = await EquipamentsService.MaintenanceHistoryList();
      setList(response.data?.data ?? []);
    } catch (error) {
      console.error(error);
      Alert.alert('Erro', 'Não foi possível carregar suas solicitações.');
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  const onRefresh = () => {
    setRefreshing(true);
    requestList();
  };

  useEffect(() => {
    requestList();
    const unsubscribe = navigation.addListener('focus', () => {
      requestList();
    });
    return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigation]);

  const goToRequest = () => navigate(AppRoutes.EQUIPMENT_MAINTENANCE);

  const renderItem = ({item}: {item: IMaintenanceHistoryItem}) => {
    const statusName = item.status?.status_name ?? '';
    const statusColor = STATUS_COLORS[statusName] ?? Colors.GrayPallete.lightgrayThree;
    return (
      <View style={ls.itemContainer}>
        <Text style={ls.itemText}>{item.desc_equipa}</Text>
        <Text style={ls.subItemText}>{item.gebra}</Text>

        <View style={ls.subItemContainer}>
          <Text style={ls.itemText}>Defeito: {item.item_description}</Text>
          <Text style={ls.itemText}>
            Protocolo: {item.protocol ?? 'Não gerado'}
          </Text>
          <Text style={[ls.itemText, {color: statusColor}]}>
            Status: {capitalize(statusName)}
          </Text>
        </View>

        <Text style={ls.subItemText}>
          Janela de visita: {item.visit_start} - {item.visit_end}
        </Text>
        {!!item.forecast && (
          <Text style={ls.subItemText}>{item.forecast}</Text>
        )}
        <Text style={ls.subItemText}>Aberto em: {formatDate(item.created_at)}</Text>
      </View>
    );
  };

  if (loading) {
    return (
      <View style={[ls.container, {justifyContent: 'center'}]}>
        <ActivityIndicator color={Colors.RedPallete.red} size="large" />
      </View>
    );
  }

  return (
    <View style={[styles.container, {marginBottom: 0}]}>
      <View style={{marginTop: 30}}>
        <SearchHeader onPress={() => goBack()} title="Manutenção de Equipamentos" />
        <Text style={ls.description}>
          Aqui você acompanha suas solicitações de manutenção
        </Text>
      </View>
      <FlatList<IMaintenanceHistoryItem>
        keyExtractor={item => `maintenance-${item.id}`}
        refreshing={refreshing}
        onRefresh={onRefresh}
        data={list}
        renderItem={renderItem}
        contentContainerStyle={list.length === 0 && {flexGrow: 1, justifyContent: 'center'}}
        ListEmptyComponent={
          <Text style={ls.errorText}>
            Você ainda não possui solicitações de manutenção.
          </Text>
        }
      />
      <View style={{marginTop: 30}}>
        <ButtonComponent onPress={goToRequest} title="Solicitar Manutenção" />
      </View>
    </View>
  );
};

export default EquipmentMaintenanceList;
